import JourneyList from '@/components/purchase/journey/JourneyList';
import { setSelectedOutboundJourney } from '@/features/purchase/purchaseActions';
import { outboundDataSelector } from '@/features/purchase/purchaseSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { GTM_EVENT } from '@/utils/gtm';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OutboundJourneyList = () => {
  const navigate = useNavigate();
  const outboundData = useSelector(outboundDataSelector);

  useEffect(() => {
    if (!outboundData.journeys) {
      navigate('/purchase');
    }
  }, [navigate, outboundData.journeys]);

  return (
    <JourneyList
      {...outboundData}
      setSelectedJourney={setSelectedOutboundJourney}
      onContinue={() => navigate('/purchase/outbound/offer')}
      journeySelectedEvent={GTM_EVENT.OUTBOUND_JOURNEY_SELECTED}
      title={<TransText i18nKey="selectOutboundTrip" />}
    />
  );
};

export default OutboundJourneyList;
